'use strict';

var accentColors = require('../../../../../../../../../_virtual/accentColors.cjs');

var AVIARY_ACCENTS = /*#__PURE__*/ function(AVIARY_ACCENTS) {
    AVIARY_ACCENTS["forest"] = "forest";
    AVIARY_ACCENTS["sand"] = "sand";
    return AVIARY_ACCENTS;
}({});

accentColors.__exports.AVIARY_ACCENTS = AVIARY_ACCENTS;

module.exports = accentColors.__exports;
//# sourceMappingURL=accentColors.cjs.map
